import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MY_DAY_ROUTE } from '../../services/routes';
import SpaceOnboardingWizard from './space_onboarding_wizard';
import { useSyncSpaceMembershipMutation } from '../../app/smorgAppSyncGraphQLApi';
import { showGlobalSnackbar } from '../../features/global_snackbar/global_snackbar_slice';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetEndUserSpaceQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const SpaceOnboardingAfterSignupContainer = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery();

  const { data: currentSpace } = useGetEndUserSpaceQuery();

  const [searchParams] = useSearchParams();
  const urlSpaceID = searchParams.get('intoSpace');
  const accountSpaceID = currentSpace?.id;
  const spaceID = urlSpaceID || accountSpaceID;

  const [syncSpaceMembership] = useSyncSpaceMembershipMutation();

  const onFinishOnboarding = useCallback(
    async (onboardingAnswers, chosenSharedProgrammeID) => {
      await syncSpaceMembership({
        spaceMembershipID: currentSpaceMembership.id,
        onboardingAnswers,
        onboardingAnswersLastUpdatedAt: new Date().toISOString(),
        customTargetCalories: currentSpaceMembership.customTargetCalories,
        welcomeVideoWatched: currentSpaceMembership.welcomeVideoWatched,
        initialProgrammeSelectionLastOfferedAt: chosenSharedProgrammeID
          ? new Date().toISOString()
          : currentSpaceMembership.initialProgrammeSelectionLastOfferedAt,
        chatNickname: currentSpaceMembership.chatNickname,
        showNutritionHeader: currentSpaceMembership.showNutritionHeader,
      });

      dispatch(
        showGlobalSnackbar({
          notificationText: 'Changes saved',
        }),
      );

      if (chosenSharedProgrammeID) {
        navigate(MY_DAY_ROUTE);
        // Allow the Back button in the shared programme onboarding wizard to work correctly
        navigate(`/shared_programmes/${chosenSharedProgrammeID}/onboard`);
      } else {
        navigate(MY_DAY_ROUTE);
      }
    },
    [currentSpaceMembership, dispatch, navigate, syncSpaceMembership],
  );

  return (
    <SpaceOnboardingWizard
      spaceID={spaceID}
      isLogoutEnabled
      onFinish={onFinishOnboarding}
    />
  );
};

export default SpaceOnboardingAfterSignupContainer;
